export class MasterUser {
  USER_ID: number;
  LOGIN_ID: string;
  USER_NAME: string;
  PROFILE_NAME: string;
  LOGIN_PASSWORD: string;
  EMAIL_ID: string;
  PHONE_NO: string;
  PASSWORD_VALIDITY: number;
  ROLE_ID: number;
  STATUS: string;
  EXPIRY_COUNT: number;
  TFLAG: string;
}
